export const GET_ALL_REPORT_CONFIGURATIONS_REQUEST = 'GET_ALL_REPORT_CONFIGURATIONS_REQUEST';
export const GET_ALL_REPORT_CONFIGURATIONS_SUCCESS = 'GET_ALL_REPORT_CONFIGURATIONS_SUCCESS';
export const GET_ALL_REPORT_CONFIGURATIONS_FAIL = 'GET_ALL_REPORT_CONFIGURATIONS_FAIL';

export const CREATE_REPORT_CONFIGURATION_REQUEST = 'CREATE_REPORT_CONFIGURATION_REQUEST';
export const CREATE_REPORT_CONFIGURATION_SUCCESS = 'CREATE_REPORT_CONFIGURATION_SUCCESS';
export const CREATE_REPORT_CONFIGURATION_FAIL = 'CREATE_REPORT_CONFIGURATION_FAIL';

export const UPDATE_REPORT_CONFIGURATION_REQUEST = 'UPDATE_REPORT_CONFIGURATION_REQUEST';
export const UPDATE_REPORT_CONFIGURATION_SUCCESS = 'UPDATE_REPORT_CONFIGURATION_SUCCESS';
export const UPDATE_REPORT_CONFIGURATION_FAIL = 'UPDATE_REPORT_CONFIGURATION_FAIL';

export const DELETE_REPORT_CONFIGURATION_REQUEST = 'DELETE_REPORT_CONFIGURATION_REQUEST';
export const DELETE_REPORT_CONFIGURATION_SUCCESS = 'DELETE_REPORT_CONFIGURATION_SUCCESS';
export const DELETE_REPORT_CONFIGURATION_FAIL = 'DELETE_REPORT_CONFIGURATION_FAIL';

export const GET_DASHBOARD_REPORTS_REQUEST = 'GET_DASHBOARD_REPORTS_REQUEST';
export const GET_DASHBOARD_REPORTS_SUCCESS = 'GET_DASHBOARD_REPORTS_SUCCESS';
export const GET_DASHBOARD_REPORTS_FAIL = 'GET_DASHBOARD_REPORTS_FAIL';
export const GET_KPI_REPORTS_REQUEST = GET_DASHBOARD_REPORTS_REQUEST;
export const GET_KPI_REPORTS_SUCCESS = GET_DASHBOARD_REPORTS_SUCCESS;
export const GET_KPI_REPORTS_FAIL = GET_DASHBOARD_REPORTS_FAIL;

export const EXPORT_REPORT_REQUEST = 'EXPORT_REPORT_REQUEST';
export const EXPORT_REPORT_SUCCESS = 'EXPORT_REPORT_SUCCESS';
export const EXPORT_REPORT_FAIL = 'EXPORT_REPORT_FAIL';

export const getAllReportConfigurationsRequest = () => ({ type: GET_ALL_REPORT_CONFIGURATIONS_REQUEST });
export const getAllReportConfigurationsSuccess = (payload) => ({ type: GET_ALL_REPORT_CONFIGURATIONS_SUCCESS, payload });
export const getAllReportConfigurationsFail = (error) => ({ type: GET_ALL_REPORT_CONFIGURATIONS_FAIL, error });

export const createReportConfigurationRequest = (data) => ({ type: CREATE_REPORT_CONFIGURATION_REQUEST, payload: data });
export const createReportConfigurationSuccess = (payload) => ({ type: CREATE_REPORT_CONFIGURATION_SUCCESS, payload });
export const createReportConfigurationFail = (error) => ({ type: CREATE_REPORT_CONFIGURATION_FAIL, error });

export const updateReportConfigurationRequest = (id, data) => ({ type: UPDATE_REPORT_CONFIGURATION_REQUEST, payload: { id, data } });
export const updateReportConfigurationSuccess = (payload) => ({ type: UPDATE_REPORT_CONFIGURATION_SUCCESS, payload });
export const updateReportConfigurationFail = (error) => ({ type: UPDATE_REPORT_CONFIGURATION_FAIL, error });

export const deleteReportConfigurationRequest = (id) => ({ type: DELETE_REPORT_CONFIGURATION_REQUEST, payload: { id } });
export const deleteReportConfigurationSuccess = (id) => ({ type: DELETE_REPORT_CONFIGURATION_SUCCESS, payload: id });
export const deleteReportConfigurationFail = (error) => ({ type: DELETE_REPORT_CONFIGURATION_FAIL, error });

export const getDashboardReportsRequest = (dashboardKey, runtimeFilters = {}) => ({
  type: GET_DASHBOARD_REPORTS_REQUEST,
  payload: { dashboardKey, runtimeFilters },
});
export const getDashboardReportsSuccess = (payload) => ({ type: GET_DASHBOARD_REPORTS_SUCCESS, payload });
export const getDashboardReportsFail = (error) => ({ type: GET_DASHBOARD_REPORTS_FAIL, error });
export const getKpiReportsRequest = getDashboardReportsRequest;
export const getKpiReportsSuccess = getDashboardReportsSuccess;
export const getKpiReportsFail = getDashboardReportsFail;

export const exportReportRequest = (reportId, runtimeFilters = {}) => ({
  type: EXPORT_REPORT_REQUEST,
  payload: { reportId, runtimeFilters },
});
export const exportReportSuccess = (reportId) => ({ type: EXPORT_REPORT_SUCCESS, payload: reportId });
export const exportReportFail = (error) => ({ type: EXPORT_REPORT_FAIL, error });
